import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How often are rates updated?',
      answer: 'Our rates are updated hourly based on official NBP (Narodowy Bank Polski) data to ensure you always get the most current and accurate exchange rates.'
    },
    {
      question: 'Do you handle large corporate transactions?',
      answer: 'Yes, we specialize in large corporate transactions and provide tailored solutions for high-volume clients. We can handle transactions of any size with competitive rates.'
    },
    {
      question: 'Is there a minimum transaction amount?',
      answer: 'No, we adapt to your company\'s needs regardless of transaction size. Whether you need to exchange €1,000 or €1,000,000, we provide the same professional corporate service.'
    },
    {
      question: 'How long does a typical transaction take?',
      answer: 'Most transactions are completed within 24 hours. For urgent requests, we can often process transactions the same day. Complex transactions may take up to 2-3 business days.'
    },
    {
      question: 'What documents do I need for currency exchange?',
      answer: 'For corporate clients, you\'ll need company registration documents, authorized signatory identification, and documentation of the transaction purpose as required by law.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg">
            Find answers to the most common questions about our currency exchange services.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <Card key={index} className="border-0 shadow-sm hover:shadow-md transition-shadow duration-300">
              <CardContent className="p-0">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full text-left p-6 flex justify-between items-center hover:bg-slate-50 transition-colors duration-200"
                >
                  <span className="font-semibold text-blue-900 text-lg pr-4">{faq.question}</span>
                  {openIndex === index ? (
                    <ChevronUp className="w-5 h-5 text-green-600 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6">
                    <div className="border-t pt-4">
                      <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Don't see your question here?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="text-green-600 hover:text-green-700 font-semibold underline"
          >
            Contact us for personalized assistance
          </button>
        </div>
      </div>
    </section>
  );
}